<template>
    <el-form :model="consumerCouponInfo"
             v-form
             editAction="dbtCard/saveConsumerCouponInfo.action"
             addAction= "dbtCard/saveConsumerCouponInfo.action"
             selectAction="dbtCard/selectConsumerCouponInfo.action"
             :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="平台券名称" prop="name">
            <el-input v-model="consumerCouponInfo.name" placeholder="如 加油满300减40元"></el-input>
        </el-form-item>
        <el-form-item label="平台券内容" prop="purpose">
            <el-input v-model="consumerCouponInfo.purpose"  placeholder="加油满减券"></el-input>
        </el-form-item>

        <el-form-item label="卡券类型" prop="type">
            <el-select v-model="consumerCouponInfo.type"  placeholder="请选择卡券类型">
                <el-option
                        v-for="item in couponTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="适用服务类型" prop="serviceType">
            <el-select v-model="consumerCouponInfo.serviceType"  placeholder="请选择服务类型">
                <el-option
                        v-for="item in serviceTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="有效期" prop="effectiveDays">
            <el-select v-model="consumerCouponInfo.effectiveDays" type="number" min="1" placeholder="请输入数量（建议30张）">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="使用方法" prop="usageMethod">
            <el-input v-model="consumerCouponInfo.usageMethod" type="textarea" :rows="3" placeholder="如 到门店后向店员展示，店员通过核销码进行核销"></el-input>
        </el-form-item>
        <el-form-item label="使用须知" prop="usageTip">
            <el-input v-model="consumerCouponInfo.usageTip" type="textarea" :rows="8" placeholder="如
1、订单满30元可用。
2、卡券有效期过期则失效。
3、每次限用一张，不能和其他优惠同时使用。
4、本券不可兑换现金，不可找零。
5、如果消费并核销适用该券后，订单发生退款，消费券无法退还。
6、此券不可转送。"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary">立即保存</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'save-consumer-coupons',
  components: { TableTemplate },
  data () {
    return {
      consumerCouponInfo: {
        id: null,
        name: null,
        purpose: null,
        effectiveDays: 30,
        usageMethod: null,
        usageTip: null,
        serviceType: null,
        type: null
      },
      options: [{
        value: 30,
        label: '领取后，30天内有效'
      }],
      couponTypes: [{
        value: 1,
        label: '优惠券'
      },
      {
        value: 2,
        label: '福利券'
      }],
      serviceTypes: [
        {
          value: '新车',
          label: '新车'
        },
        {
          value: '二手车',
          label: '二手车'
        },

        {
          value: '美容保养',
          label: '美容保养'
        },
        {
          value: '洗车打蜡',
          label: '洗车打蜡'
        },
        {
          value: '装饰配件',
          label: '装饰配件'
        },
        {
          value: '改装装潢',
          label: '改装装潢'
        },
        {
          value: '汽车维修',
          label: '汽车维修'
        },
        {
          value: '其他服务',
          label: '其他服务'
        }

      ],
      rules: {
        name: [
          { required: true, message: '请输入平台券名称', trigger: 'blur' }
        ],
        purpose: [
          { required: true, message: '请输入平台券内容', trigger: 'blur' }
        ],
        usageMethod: [
          { required: true, message: '请输入使用方法', trigger: 'blur' }
        ],
        usageTip: [
          { required: true, message: '请输入使用须知', trigger: 'blur' }
        ],
        effectiveDays: [
          { required: true, message: '请输入有效期', trigger: 'blur' }
        ],
        serviceType: [
          { required: true, message: '请选择服务类型', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择卡券类型', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.consumerCouponInfo.id = this.$route.params.id
  }
}
</script>
